'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('FuncoesCtrl', function($scope, $rootScope, $location, $routeParams,
  Flash, FuncoesService, LoadingService, MessagesService) {
  const initializeVariables = function() {
    $scope.filters = {};
    $scope.funcoes = null;
    $scope.pages = {};
  };

  const initialize = function() {
    LoadingService.showLoading();
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.funcao.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      if ($routeParams.id) {
        const error = function() {
          Flash.create(REGISTRO_NAO_EXISTE.type, REGISTRO_NAO_EXISTE.msg);
          $location.path('/funcoes');
        };
        FuncoesService.get($routeParams.id).then(function(funcao) {
          $scope.funcao = funcao;

          if (!$scope.$root.parametros.nao_cliente_agrogestao) {
            $scope.funcao.itens = $scope.funcao.itens.filter((item) => (
              !FuncoesService.funcoesNaoClienteAgrogestao.includes(item.id)
            ));
          }
        }, error)
          .finally(LoadingService.hideLoading);
      } else {
        initializeVariables();
        $scope.buscarClick();
      }
    }, $rootScope.errorRootInitialize);
  };

  $scope.getFuncoes = function() {
    LoadingService.showLoading();
    $scope.funcoes = null;
    FuncoesService.list($scope.filters).then(function(data) {
      $scope.funcoes = data.data || [];
      $scope.pages = data.pages || {};
    }, function() {
      MessagesService.alert('Não foi possível buscar as Funções.');
    })
      .finally(LoadingService.hideLoading);
  };

  $scope.setPage = function(page) {
    const isEqual = $scope.filters.page && $scope.filters.page === page;
    if ((typeof(page) === 'undefined') || (!$scope.filters.page && page === 1) || isEqual) {
      return;
    }
    $scope.filters.page = page;
    $scope.getFuncoes();
  };

  $scope.buscarClick = function() {
    $scope.filters.page = null;
    $scope.getFuncoes();
  };

  $scope.goToIndex = function() {
    $location.path('/funcoes');
  };

  const setUrlFuncao = function(funcao, url) {
    if (funcao) {
      $location.path(`/funcoes/${ funcao.id }${url || ''}`);
    }
  };

  $scope.show = function(index) {
    LoadingService.showLoading();
    setUrlFuncao($scope.funcoes[index]);
  };

  $scope.reply = function() {
    MessagesService.confirm('Deseja replicar a função?').then(function() {
      setUrlFuncao($scope.funcao, '/new');
    });
  };

  $scope.edit = function() {
    setUrlFuncao($scope.funcao, '/edit');
  };

  $scope.delete = function() {
    MessagesService.confirm('Deseja excluir a função?').then(function() {
      LoadingService.showLoading();
      FuncoesService.delete($scope.funcao.id).then(function() {
        $scope.goToIndex();
        Flash.create(REGISTRO_EXCLUIDO_COM_SUCESSO.type, REGISTRO_EXCLUIDO_COM_SUCESSO.msg);
      }, function() {
        MessagesService.alert(FALHA_AO_EXCLUIR_REGISTRO.msg);
      })
        .finally(LoadingService.hideLoading);
    });
  };

  initialize();
});
